import svg4everybody from "svg4everybody";
import cookie from "./_cookie";
import textRotor from "./_textRotor";
import videoPopup from "./_videoPopup";
import addAnimationToHeader from "./_animateHeader";
import setPlatformDependentDownloadLink from "./_platformDependentDownloadBtn";
import addAnimationToFeatureImage from './_animateFeatureImage';
import newsletterPopup from './_newsletterPopup';

document.addEventListener("DOMContentLoaded", function () {
  svg4everybody();

  // Text rotor
  let els = document.querySelectorAll(".js-rotor");
  if (els.length > 0) {
    [].forEach.call(els, el => {
      textRotor(el);
    });
  }

  // Video modal
  els = document.querySelectorAll(".js-video-modal");
  if (els.length > 0) {
    [].forEach.call(els, el => {
      videoPopup(el);
    });
  }

  const lazyVideos = [].slice.call(document.querySelectorAll(".js-lazy-video"));

  if ("IntersectionObserver" in window) {
    var lazyVideoObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (video) {
        if (video.isIntersecting) {
          for (var source in video.target.children) {
            var videoSource = video.target.children[source];
            if (
              typeof videoSource.tagName === "string" &&
              videoSource.tagName === "SOURCE"
            ) {
              videoSource.src = videoSource.dataset.src;
            }
          }

          video.target.load();
          video.target.classList.remove("lazy");
          lazyVideoObserver.unobserve(video.target);
        }
      });
    });

    lazyVideos.forEach(function (lazyVideo) {
      lazyVideoObserver.observe(lazyVideo);
    });
  }

  addAnimationToHeader();
  addAnimationToFeatureImage();
  newsletterPopup();

  // Make download button platform dependent
  setPlatformDependentDownloadLink();
});
